import { render } from "./Close.vue?vue&type=template&id=673c39da"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Close.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "673c39da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('673c39da', __exports__)) {
    api.reload('673c39da', __exports__)
  }
  
  module.hot.accept("./Close.vue?vue&type=template&id=673c39da", () => {
    api.rerender('673c39da', render)
  })

}


export default __exports__